app.controller('mainController', ['$scope', '$rootScope', '$state', '$injector', 'config', 'objectHelper', 'applicationModel',
                'userModel', '$mdSidenav', '$mdUtil', '$translate',
    function($scope, $rootScope, $state, $injector, config, objectHelper, applicationModel, userModel, $mdSidenav,
             $mdUtil, $translate) {

        function checkForUserFunctions() {
            if(!$scope.payments.length && !$scope.subscriptions.length) {
                var sideBarItems = [
                    objectHelper.translateObject({name: "{{ 'T.UI.SIDEBAR_ITEMS.MAIN' | translate }}", icon: 'home', state: Constant.STATE.APP.HOME}, EsSidebarItem),
                    objectHelper.translateObject({name: "{{ 'T.UI.SIDEBAR_ITEMS.PATIENTS' | translate }}", icon: 'people', state: Constant.STATE.APP.PATIENT.LIST}, EsSidebarItem),
                    objectHelper.translateObject({name: "{{ 'T.UI.SIDEBAR_ITEMS.BASE_OF_CASES' | translate }}", icon: 'art_track', state: Constant.STATE.APP.BASE_OF_CASE.SEARCH}, EsSidebarItem),
                    objectHelper.translateObject({name: "{{ 'T.UI.SIDEBAR_ITEMS.BUSINESS_INTELLIGENCE' | translate }}", icon: 'timeline', state: Constant.STATE.APP.BUSINESS_INTELLIGENCE}, EsSidebarItem),
                    objectHelper.translateObject({name: "{{ 'T.UI.SIDEBAR_ITEMS.MEDICAL_DOCUMENTATION' | translate }}", icon: 'assignment', state: Constant.STATE.APP.FILL_DATA}, EsSidebarItem)

                ];

                applicationModel.setSideBarItems(sideBarItems);

            }
        }

        function setData() {
            $scope.applicationItems = $scope.bindData(function() { return applicationModel.applicationItems }, 'applicationItems', $scope);
            $scope.menuItems = $scope.bindData(function() { return applicationModel.menuItems }, 'menuItems', $scope);
            $scope.sideBarItems = $scope.bindData(function() { return applicationModel.sideBarItems }, 'sideBarItems', $scope);
            $scope.breadcrumbItems = $scope.bindData(function() { return applicationModel.breadcrumbItems }, 'breadcrumbItems', $scope);
            $scope.titleBar = $scope.bindData(function () { return applicationModel.titleBar }, 'titleBar', $scope);

            $scope.slidePanelState = $scope.bindData(function() { return applicationModel.slidePanelState }, 'slidePanelState', $scope);

            $scope.currentUser = $scope.bindData(function() { return userModel.currentUser }, 'currentUser', $scope);

            $scope.currentPatient = null;
            $scope.patientsPages = [];
            $scope.patientCriteria = new PatientDataGridCriteria();
            $scope.dataLoading = false;

            $scope.toggleLeft = buildToggler('left');

            $translate.use(userModel.selectedLanguage ? userModel.selectedLanguage : 'pl_PL');
            /**
             * Build handler to open/close a SideNav; when animation finishes
             * report completion in console
             */
            function buildToggler(navID) {
                var debounceFn =  $mdUtil.debounce(function(){
                    $mdSidenav(navID)
                        .toggle()
                        .then(function () {
                        });
                },200);
                return debounceFn;
            }

            $scope.payments = [];
            $scope.subscriptions = [];
        }

        function setListeners() {
            $scope.bindChange(function() { return userModel.currentUser }, function onCurrentUserChange(newValue, oldValue, scope) {
                var loggedUser = newValue;
                if (loggedUser) {
                    $translate.use(userModel.selectedLanguage ? userModel.selectedLanguage : 'pl_PL');
                    applicationModel.isLoggedIn = true;

                }
            }, $scope);

            $scope.$on('$destroy', function (event) {
                $scope.unbind($scope);
            });

            $scope.toggleSidenav = function(menuId) {
                $mdSidenav(menuId).toggle();
            };

            if(config.MEEDY) {
                $scope.$on(Event.MEEDY.USER.GET_LOGGED_USER.SUCCESS, function(event, loggedUser) {
                    $translate.use(userModel.selectedLanguage ? userModel.selectedLanguage : 'pl_PL');
                    applicationModel.isLoggedIn = true;

                });
            }
        }

        function setActions() {
            $scope.logout = function () {
                if($injector.has('meedyConfig')) {
                    var meedyAuthModel = $injector.get('meedy.authModel');
                    meedyAuthModel.invalidate();
                    $state.go(Constant.STATE.APP.MEEDY.LOGOUT);
                } else if($injector.has('edmConstant')) {
                    $state.go(Constant.STATE.APP.LOGOUT);
                }
            };

            if (config.MEEDY) {
                $scope.changePassword = function() {
                    $state.go(Constant.STATE.APP.MEEDY.ACCOUNT.CHANGE_PASSWORD);
                };
            }
        }


        function initialize() {
            if(!userModel.currentUser) {
                userModel.getLoggedUser();
            }
            if(config.MEEDY && $injector.has('meedy.userModel')) {
                var meedyUserModel = $injector.get('meedy.userModel');
                if(!meedyUserModel.currentUser) {
                    meedyUserModel.getLoggedUser();
                }
            }
        }

        setData();
        setListeners();
        setActions();
        initialize();






    }
]);
